import Vue from 'vue';
import Router from 'vue-router';
import ListCustomers from './views/ListCustomers.vue';
import ViewCustomer from './views/ViewCustomer.vue';
import ListLicenses from './views/ListLicenses.vue';
import ViewLicense from './views/ViewLicense.vue';
import NewLicense from './views/NewLicense.vue';
import SoftwareUpdates from './views/SoftwareUpdates.vue';
import SignIn from './views/SignIn.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/customers',
      name: 'list-customers',
      component: ListCustomers,
    },
    {
      path: '/customers/:ID',
      name: 'view-customer',
      component: ViewCustomer,
    },
    {
      path: '/licenses',
      name: 'list-licenses',
      component: ListLicenses,
    },
    {
      path: '/licenses/new/:ID?',
      name: 'new-license',
      component: NewLicense,
    },
    {
      path: '/licenses/:ID',
      name: 'view-license',
      component: ViewLicense,
    },
    {
      path: '/signin',
      name: 'signin',
      component: SignIn,
    },
    {
      path: '/software-updates',
      name: 'software-updates',
      component: SoftwareUpdates,
    },
    {
      path: '/',
      redirect: '/customers',
    },
  ],
});
